// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

/** 说话背景和文字位置差 */
// const c_TalkSpaceY = 76;
const c_opacityTime = 0.25;
@ccclass
export default class SettleLawsuitPrimaryPeopleNode extends BaseComponent {

	@property({ type: cc.Label, displayName:'' })
	labelLv: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeLv: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeInfo: cc.Node = null;

	// @property({ type: cc.Node, displayName:'' })
	// levelNameNode: cc.Node = null;
	@property({ type: cc.Node, displayName:'' })
	nodeName: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeTalk: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelTalk: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	sprTalkBg: cc.Node = null;

    @property(cc.Label)
    labelName: cc.Label = null;

    @property({ type: sp.Skeleton, displayName:'' })
	sprPeople: sp.Skeleton = null;
    
    /** 最小高度 */
    // private minTalkHeight = 0;
    private maxTalkWidth = 0;
    private talkSpaceX = 0;
    private talkSpaceY = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        // this.minTalkHeight = this.sprTalkBg.height;
        this.maxTalkWidth = this.labelTalk.node.width;
        this.talkSpaceX = this.sprTalkBg.width - this.labelTalk.node.width;
        this.talkSpaceY = this.sprTalkBg.height - this.labelTalk.node.height;

        this.nodeTalk.active = false;
        this.initUI();
    }

    setLevel(lv: string) {

        // this.levelNameNode.active = false;
        if (!utilsModel.isValidNumberValue(lv)) {
            this.nodeLv.active = false;
            // this.nodeName.getComponent(cc.Widget).top += 33;
            return;
        }
        
        let info = CsvDataManage.instance.getCsvDataItem(
            CsvFileKind.CsvFile.LEVEL, lv);
        if (!info) {
            console.error(`未找到等级数据`);
            return;
        }
        this.nodeLv.active = true;
        this.labelLv.string = info.level_name;
        // this.levelNameNode.active = true;
        // let LevelNameNode = cc.find('LevelNameNode', this.levelNameNode);
        // let sprLevelBg = cc.find('sprLevelBg', LevelNameNode).getComponent(cc.Sprite);
        // let label = cc.find('labelLevelName', LevelNameNode).getComponent(cc.Label);
        // label.string = info.level_name;
        // if (sprLevelBg) {
        //     let csvInfos = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEVEL, lv);
        //     if (!csvInfos) {
        //         console.error(`未找到表格数据`);
        //         return;
        //     }
        //     let icon = csvInfos.icon;
        //     O1HD.getManagers().gameMgr.getCurrMode().bundle.load(
        //         `res/user/levelIcon/${icon}`
        //         , cc.SpriteFrame
        //         , ( error , assets : cc.SpriteFrame )=>
        //         {
        //             if ( error ) {
        //                 console.log("图片加载失败");
        //                 return
        //             }
        //             sprLevelBg.spriteFrame = assets;
        //         }
        //     );
        // }
    }

    initUI() {
        let id = this._carryData.id;
        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEGAL_CASE_PEOPLE, id);
        if (!info) {
            console.error(`未找到头像数据`);
            return;
        }

        this.setLevel(info.level);
        this.labelName.string = info.name;

        this.sprPeople.node.active = false;
        let meHead = "res/common/person/spine/" + info.icon_max;
        let self = this;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.settleLawsuitBundle).load(meHead, sp.SkeletonData
            , (err,imgs:sp.SkeletonData)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprPeople.node.active = true;
                    this.sprPeople.skeletonData = imgs;
                    this.playPeopleAni('Idle', true);
                    // this.sprPeople.spriteFrame = imgs;
                    self.nodeInfo.y = self.sprPeople.node.height * self.sprPeople.node.scaleY;

                    self.nodeName.x = (self._carryData.idx == 0 ? 1 : -1) * self.nodeName.x;
                    // self.nodeName.x = (self._carryData.idx == 0 ? -1 : 1) * 
                    // (self.sprPeople.node.width/2 * self.sprPeople.node.scaleX + 20);
                }
            }
        );
    }
    
    playPeopleAni(name: string, bLoop: boolean, bAligning: boolean = false) {
        this.sprPeople.setSkin(name)
        this.sprPeople.setAnimation(0, name, bLoop);

        this.sprPeople.setCompleteListener(()=> {
            if (bLoop == true) {
                return;
            }
            if (bAligning) {
                this.playPeopleAni('Idle', true);
            }
        });
    }

    onClick() {
        // this._carryData.parent.closeAllPeopleTalk();
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
    }

    async showTalkAni(str: string) {
        return new Promise<void>(resolve=> {
            this.showTalk(str);

            cc.Tween.stopAllByTarget(this.nodeTalk);
            this.nodeTalk.active = true;
            this.nodeTalk.opacity = 0;
            const time = c_opacityTime;
            cc.tween(this.nodeTalk)
            .to(time, {opacity: 255})
            .delay(3.5)
            .to(time, {opacity: 0})
            .call(()=> {
                if (this.node && cc.isValid(this.node)) {
                    this.nodeTalk.active = false;    
                }
                resolve();
            })
            .start();
        });
        
    }

    showTalk(str: string) {

        this.labelTalk.overflow = cc.Label.Overflow.NONE;
        this.labelTalk.string = str;
        utilsView.refreshLabelUI(this.labelTalk);
        if (this.labelTalk.node.width > this.maxTalkWidth) {
            this.labelTalk.overflow = cc.Label.Overflow.RESIZE_HEIGHT;
            this.labelTalk.node.width = this.maxTalkWidth;
            utilsView.refreshLabelUI(this.labelTalk);
        } else {
            this.labelTalk.node.anchorX = 0.5;
            this.labelTalk.node.x = 0;
        }

        this.sprTalkBg.width = this.labelTalk.node.width + this.talkSpaceX;
        this.sprTalkBg.height = this.labelTalk.node.height + this.talkSpaceY;
    }

    hideTalk() {
        if (!this.nodeTalk.active) {
            return;
        }
        cc.Tween.stopAllByTarget(this.nodeTalk);
        this.nodeTalk.active = false;

        // cc.tween(this.nodeTalk)
        // .to(c_opacityTime, {opacity: 0})
        // .call(()=> {
        //     this.nodeTalk.active = false;
        // })
        // .start();
    }

    // update (dt) {}
}
